(function () {
  var LABEL = 'המחירים כוללים מע״מ · משלוח חינם לכל הארץ';

  /* ------------------------------------------------------------------
     1. Cart: quantity 0 removes the line and the totals refresh.
     ------------------------------------------------------------------ */
  function patchQuantityValidation() {
    if (typeof CartItems === 'undefined' || !CartItems.prototype) return false;
    if (CartItems.prototype.vetoraZeroRemovesLine) return true;
    CartItems.prototype.vetoraZeroRemovesLine = true;
    var original = CartItems.prototype.validateQuantity;
    CartItems.prototype.validateQuantity = function (event) {
      var value = parseInt(event.target.value, 10);
      var index = event.target.dataset.index;
      if (isNaN(value)) { this.resetQuantityInput(index); return; }
      if (value === 0) {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(index, 0, event,
          document.activeElement && document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId);
        return;
      }
      return original.call(this, event);
    };
    return true;
  }

  function relabelTaxNotes(root) {
    var notes = (root || document).querySelectorAll('.tax-note');
    for (var i = 0; i < notes.length; i++) {
      if (notes[i].getAttribute('data-vetora-note') === '1') continue;
      notes[i].setAttribute('data-vetora-note', '1');
      notes[i].textContent = LABEL;
    }
  }

  /* ------------------------------------------------------------------
     2. Selling plan + subscription price, per package.

     Each package now has its own selling plan, so the tier can carry its own
     fixed discount. The product template was built for a single shared plan:
     it keeps the first package's plan id in the form and prints the one-time
     price in the subscription row for every other package. Left alone that
     means "add to cart" silently adds nothing on the 2- and 3-packs, and the
     subscription price is never shown on them.

     Both are read straight from the product's own selling plan allocations,
     so nothing here needs updating when prices or discounts change.
     ------------------------------------------------------------------ */
  var planByVariant = null;
  var subPriceByVariant = null;
  var planLoading = false;

  function money(cents) {
    return '₪' + (cents / 100).toFixed(2);
  }

  function loadPlans() {
    if (planByVariant || planLoading) return;
    var match = window.location.pathname.match(/\/products\/[^\/?#]+/);
    if (!match) { planByVariant = {}; subPriceByVariant = {}; return; }
    planLoading = true;
    fetch(match[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        var plans = {};
        var prices = {};
        if (product && product.variants) {
          for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            var allocations = v.selling_plan_allocations || [];
            if (allocations.length) {
              plans[String(v.id)] = String(allocations[0].selling_plan_id);
              prices[String(v.id)] = allocations[0].per_delivery_price;
            }
          }
        }
        planByVariant = plans;
        subPriceByVariant = prices;
        planLoading = false;
        syncSubscription();
      })
      .catch(function () { planByVariant = {}; subPriceByVariant = {}; planLoading = false; });
  }

  function currentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var idInput = form.querySelector('[name="id"]');
    return idInput && idInput.value ? String(idInput.value) : null;
  }

  function syncSubscription() {
    if (!planByVariant) return;

    /* the hidden plan id on every add-to-cart form */
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var planInput = forms[i].querySelector('[name="selling_plan"]');
      if (!planInput || !planInput.value) continue;
      var idInput = forms[i].querySelector('[name="id"]');
      if (!idInput || !idInput.value) continue;
      var wanted = planByVariant[String(idInput.value)];
      if (wanted && planInput.value !== wanted) planInput.value = wanted;
    }

    /* the price printed in the subscription row */
    var vid = currentVariantId();
    if (!vid || !subPriceByVariant) return;
    var price = subPriceByVariant[vid];
    if (price == null) return;
    var text = money(price);
    var labels = document.querySelectorAll('[data-dlp-price-sub]');
    for (var j = 0; j < labels.length; j++) {
      if (labels[j].textContent.trim() !== text) labels[j].textContent = text;
    }
  }

  function boot() {
    patchQuantityValidation();
    relabelTaxNotes(document);
    loadPlans();
    syncSubscription();
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);

  /* Sync at the last possible moment, before the theme's own submit handler. */
  document.addEventListener('submit', syncSubscription, true);
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest) setTimeout(syncSubscription, 0);
  }, true);
  document.addEventListener('change', function () { setTimeout(syncSubscription, 0); }, true);

  var tries = 0;
  var timer = setInterval(function () {
    if (patchQuantityValidation() || ++tries > 60) clearInterval(timer);
  }, 100);

  var settle = setInterval(syncSubscription, 400);
  setTimeout(function () { clearInterval(settle); }, 20000);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      relabelTaxNotes(document);
      syncSubscription();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
